import type { FunctionComponent } from 'react'

import { GamPanel } from '../../../../shared'
import { usePageGamConfig } from '../../../../shared/hooks/usePageGamConfig'
import type { PageInfo } from '../../../../shared/types'
import { useCtaRecommendationCtaService } from '../../../home/hooks/useCtaRecommendation'

type Props = { pageInfo: PageInfo }

export const ArticlePageBodyGam: FunctionComponent<Props> = ({ pageInfo }) => {
  const gamConfig = usePageGamConfig({ pageInfo })

  const { ctaId, loading } = useCtaRecommendationCtaService()

  if (gamConfig === undefined) {
    return null
  }

  if (loading) {
    return null
  }

  return (
    <div>
      <GamPanel
        {...gamConfig}
        ctaId={ctaId}
        gamId="div-gpt-ad-6221233-1"
        panelName="articleBody"
        sizeMappings={[
          [[1270, 0], [[600, 250]]],
          [[375, 0], [[300, 250]]],
          [[0, 0], []],
        ]}
      />
      <ArticlePageBodyOutOfPageGam pageInfo={pageInfo} />
    </div>
  )
}

export const ArticlePageBodyOutOfPageGam: FunctionComponent<Props> = ({ pageInfo }) => {
  const gamConfig = usePageGamConfig({ pageInfo })

  const { ctaId, loading } = useCtaRecommendationCtaService()

  if (gamConfig === undefined) {
    return null
  }

  if (loading) {
    return null
  }

  return (
    <>
      <GamPanel
        {...gamConfig}
        ctaId={ctaId}
        gamId="div-gpt-ad-6221233-2"
        panelName="articleBodyOutOfPage"
        pos="acquisition_banner"
        isOOP={true}
      />
      <GamPanel
        {...gamConfig}
        ctaId={ctaId}
        gamId="div-gpt-ad-6221233-3"
        panelName="articleBodyOutOfPage2"
        pos="pop_up"
        isOOP={true}
      />
    </>
  )
}
